import * as React from 'react'
import { connect } from 'react-redux';
import { WithMediaQuery } from '../../layout/withMediaQuery';
import { withStyles, StyledComponentProps, Grid, CircularProgress, Dialog } from '@material-ui/core';
import { styles } from './styles';
import { IApplicationState } from '../../store/ApplicationState';
import { IActions, actionCreator } from './store/actions/creators';
import { IState } from './store/state';
import Paper from '../../ui-components/Containers/Paper';
import { ActivityDefinitions } from './components/ActivityDefinitions';
import { Alert } from '@material-ui/lab';
import { Details } from './components/details/Details';
import { Filters } from './components/Filters';
import { tag } from '../../model/tag';
import { actionCreator as tagsActions, IActions as ITagsActions } from '../tags/store/actions/creators'
import { actionCreator as trainerActions, IActions as ITrainersActions } from '../../common/store/trainers/actions/creators'
import { NewActivityDefinition } from './components/newActivity/NewActivityDefinition';
import { ActivityDefinition, ActivitySchedule, ActivityState } from '../../model/activities';
import { BigCalendar } from '../../ui-components/BigCalendar/BigCalendar';
import moment from 'moment';
import { CalendarDetail } from '../../ui-components/BigCalendar/eventDetails/CalendarDetail';
import { stringOrDate } from 'react-big-calendar';
import { EmptyEventComponent } from '../../ui-components/BigCalendar/eventDetails/EmptyEventComponent';
import { trainer } from '../../model/trainer';

interface IProps extends IActions, IState, StyledComponentProps, ITagsActions, ITrainersActions {
    allTags: tag[],
    allTrainers: trainer[]
}
interface IInternalState {
    popupNewActivity: boolean;
    filtered: ActivityDefinition[];
    popupCalendar: boolean;
    currentPeriod: { start: stringOrDate; end: stringOrDate }
}
const getMonday = (d: Date) => {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}
const getSunday = (d: Date) => {
    var ret = new Date(d || new Date());
    ret.setDate(ret.getDate() + (6 - ret.getDay() + 7) % 7 + 1);
    return ret;
}

class ActivitiesContainerComponent extends React.Component<IProps, IInternalState> {
    constructor(p, c) {
        super(p, c);
        this.state = { popupNewActivity: false, filtered: undefined, popupCalendar: false, currentPeriod: { start: getMonday(new Date()), end: getSunday(new Date()) } }
    }

    filter = (description: string, tag: tag) => {
        if (!Boolean(tag || description))
            this.setState({ filtered: undefined });
        else {
            let ret = this.props.allActivities;
            if (!ret || ret.length === 0)
                return ret;
            if (description)
                ret = this.props.allActivities.filter(a => a.description.toLowerCase().indexOf(description.toLowerCase()) > -1
                    || a.displayName.toLowerCase().indexOf(description.toLowerCase()) > -1);
            if (tag)
                ret = ret.filter(a => a.tag._id === tag._id);
            this.setState({ filtered: ret });
        }
    }
    componentDidMount() {
        if (!this.props.allTags || !this.props.allTags.length)
            this.props.loadTags();
        if (!this.props.allActivities || !this.props.allActivities.length)
            this.props.loadActivities();
        if (!this.props.allTrainers || !this.props.allTrainers.length)
            this.props.loadTrainers();
    }
    newActivity = () => {
        this.setState({ popupNewActivity: true });
    }
    selectActivity = (id: string) => {
        this.props.selectActivity(id);
    }
    saveNewActivity = (definition: ActivityDefinition, schedules: ActivitySchedule[]) => {
        this.props.saveNewActivity(definition, schedules).then(a => this.setState({ popupNewActivity: false }));
    }
    updateSchedule = (a: ActivitySchedule, updateSimilar: boolean) => {
        this.props.saveSchedule(a, updateSimilar);
    }
    createSchedule = (a: ActivitySchedule) => {
        this.props.createSchedule(a);
    }
    createSchedules = (a: ActivitySchedule[]) => {
        this.props.createSchedules(a);
    }
    deleteSchedule = (id: string) => {
        this.props.deleteSchedule(id);
    }
    deleteSchedules = (id: string[]) => {
        this.props.deleteSchedules(id);
    }
    onRangeChange = (start: stringOrDate, end: stringOrDate) => {
        this.setState({ currentPeriod: { start: start, end: end } });
    }
    getEventsCount = () => {
        if (this.state.currentPeriod && this.props.currentSchedules) {
            return this.props.currentSchedules.filter(s => s.date > this.state.currentPeriod.start && s.date <= this.state.currentPeriod.end).length;
        }
        return 0;
    }
    approvaPianificazione = (a: ActivityDefinition) => {
        a.state = ActivityState.approved;
        this.props.save(a);
        const schedulesToUpdate = [...this.props.currentSchedules].map(a => { return { ...a, state: ActivityState.approved } });
        this.props.saveSchedules(schedulesToUpdate);
    }
    render() {
        return <Grid container spacing={1}>
            <Grid item xs={12}>
                <Filters
                    loading={this.props.isLoading}
                    new={this.newActivity}
                    allActivities={this.props.allActivities}
                    allTags={this.props.allTags}
                    classes={this.props.classes}
                    search={this.filter}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Paper title='Elenco'
                    collapsed={false}
                    fullHeight={false}
                    contentContainerStyle={{
                        heigth: 'calc(100% - 1px)'
                    }}
                >
                    <Grid container spacing={1}>
                        {this.props.isLoading ?
                            <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
                                <CircularProgress size={80} />
                            </Grid>
                            :
                            <Grid item xs={12} >
                                <ActivityDefinitions
                                    classes={this.props.classes}
                                    selectedId={this.props.activityDefinition?._id}
                                    allActivities={this.state.filtered !== undefined ? this.state.filtered : this.props.allActivities}
                                    onSelected={this.selectActivity}
                                    navigateTo={this.props.navigateTo}
                                    delete={this.props.delete}
                                    confirm={this.props.confirm}
                                />
                            </Grid>
                        }
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Paper title='Dati' fullHeight contentContainerStyle={{ padding: 8 }} id="Activitydefinition">
                    <Grid container spacing={1}>
                        {this.props.isLoading || this.props.isLoadingDetails ?
                            <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
                                <CircularProgress size={80} />
                            </Grid>
                            : (this.props.fetchError ?
                                <Grid item xs={12}>
                                    <Alert severity="error">Error while fetching details</Alert>
                                </Grid>
                                :
                                <Grid item xs={12}>
                                    {this.props.activityDefinition ? <Details
                                        trainers={this.props.allTrainers}
                                        onApprove={this.approvaPianificazione}
                                        addSchedules={this.createSchedules}
                                        removeSchedules={this.deleteSchedules}
                                        openCalendar={() => this.setState({ popupCalendar: true })}
                                        tags={this.props.allTags}
                                        classes={this.props.classes}
                                        setActivity={this.props.updateActivity}
                                        activity={this.props.activityDefinition}
                                        schedules={this.props.currentSchedules}
                                        onDelete={this.props.delete}
                                        onSave={this.props.save}
                                        onCancel={() => this.props.selectActivity(this.props.activityDefinition._id)} /> : null}
                                </Grid>
                            )}
                    </Grid>
                </Paper>
            </Grid>
            <Dialog maxWidth={'lg'} open={this.state.popupNewActivity} onClose={() => this.setState({ popupNewActivity: false })}>
                <NewActivityDefinition trainers={this.props.allTrainers} saveSchedule={this.saveNewActivity} tags={this.props.allTags} onCancel={() => this.setState({ popupNewActivity: false })} classes={this.props.classes} />
            </Dialog>
            <Dialog fullWidth maxWidth={'lg'} open={this.state.popupCalendar} onClose={() => this.setState({ popupCalendar: false })}>
                <BigCalendar
                    height={500}
                    onRangeChange={this.onRangeChange}
                    selectedEvent={getEvent(this.props.addedSchedule)}
                    renderEmptyDetail={() => <EmptyEventComponent
                        onCreate={this.createSchedule}
                        events={this.getEventsCount()}
                        trainers={this.props.allTrainers}
                        sourceActivity={this.props.activityDefinition}
                        classes={this.props.classes} />}
                    renderDetail={e => <CalendarDetail
                        trainers={this.props.allTrainers}
                        onAddReservation={this.props.addReservation}
                        onRemoveReservation={this.props.removeReservation}
                        loading={this.props.isLoadingDetails}
                        onSave={this.updateSchedule}
                        onDelete={this.deleteSchedule}
                        event={e}
                        classes={this.props.classes}
                        minDate={this.props.activityDefinition?.validFrom}
                        maxDate={this.props.activityDefinition?.expiresOn} />}
                    views={['week', 'day', 'month']}
                    defaultView='week'
                    title='Ricorrenze attività'
                    events={(this.props.currentSchedules || []).map(s => getEvent(s))} />
            </Dialog>
        </Grid>
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.activities,
    allTags: [...state.tags.tags],
    allTrainers: [...state.trainers.trainers]
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch),
        ...tagsActions(dispatch),
        ...trainerActions(dispatch)
    }
};
const getEvent = (s: ActivitySchedule) => {
    if (s)
        return {
            start: s.date,
            end: moment(s.date).add(s.duration, 'm').toDate(),
            title: s.displayName,
            resource: s,
            color: s.tag?.color || 'green'
        }
    return undefined;
}
export const ActivitiesContainer = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles as any)(ActivitiesContainerComponent)));